export const AddReview = () => {
    return (
        <>
            <div id="add-review" class="add-review-box">
                {/* <!-- Add Review --> */}
                <h3 class="listing-desc-headline margin-bottom-10">Add Review</h3>
                <p class="comment-notes">Your email address will not be published.</p>

                {/* <!-- Subratings Container --> */}
                <div class="sub-ratings-container">
                    {/* <!-- Subrating #1 --> */}
                    {/* <!-- Leave Rating --> */}
                    <form class="leave-rating">
                        <input type="radio" name="rating" id="rating-1" value="1" />
                        <label for="rating-1" class="fa fa-star"></label>
                        <input type="radio" name="rating" id="rating-2" value="2" />
                        <label for="rating-2" class="fa fa-star"></label>
                        <input type="radio" name="rating" id="rating-3" value="3" />
                        <label for="rating-3" class="fa fa-star"></label>
                        <input type="radio" name="rating" id="rating-4" value="4" />
                        <label for="rating-4" class="fa fa-star"></label>
                        <input type="radio" name="rating" id="rating-5" value="5" />
                        <label for="rating-5" class="fa fa-star"></label>
                    </form>
                </div>
                {/* <!-- Subratings Container / End --> */}

                {/* <!-- Review Comment --> */}
                <form id="add-comment" class="add-comment">
                    <fieldset>

                        <div class="row">
                            <div class="col-md-6">
                                <label>Name:</label>
                                <input type="text" value="" />
                            </div>

                            <div class="col-md-6">
                                <label>Email:</label>
                                <input type="text" value="" />
                            </div>
                        </div>

                        <div>
                            <label>Review:</label>
                            <textarea cols="10" rows="3"></textarea>
                        </div>

                    </fieldset>
                    {/* <!-- Uplaod Photos --> */}
                    {/* <div class="uploadButton margin-top-15">
                                    <input class="uploadButton-input" type="file" name="attachments[]" accept="image/*, application/pdf" id="upload" multiple />
                                    <label class="uploadButton-button ripple-effect" for="upload">Add Photos</label>
                                    <span class="uploadButton-file-name"></span>
                                </div> */}
                    {/* <!-- Uplaod Photos / End --> */}
                    <button class="button">Submit Review</button>
                    <div class="clearfix"></div>
                </form>
            </div>
        </>
    )
}